
import locale from 'antd/lib/date-picker/locale/zh_CN';
import moment from 'moment';
window.GLOBAL_PARAMS = {
  locale :locale,
  moment :moment,
}
